import React, { useState, useEffect } from "react";
import { Calendar } from "lucide-react";

const BlogsCards = () => {
  const API_URL = "https://dgl-core-9x7.dailygolive.in/api/blogs";
  const IMAGE_BASE_URL = "https://dgl-core-9x7.dailygolive.in"; // ✅ prepend backend domain
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ fetch blogs
  const fetchBlogs = async () => {
    try {
      setLoading(true);
      // Add cache-busting query param so deleted blogs don't show from cache
      const res = await fetch(`${API_URL}?t=${Date.now()}`, {
        cache: "no-store",
      });
      if (!res.ok) throw new Error("Failed to fetch blogs");
      const data = await res.json();
      setBlogs(data);
    } catch (err) {
      console.error("❌ Error fetching blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();

    // ✅ optional: auto-refresh every 20s
    const interval = setInterval(fetchBlogs, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-gradient-to-br from-amber-50 via-amber-100 to-amber-50 py-16 px-5 md:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-12">
          <h4 className="text-amber-700 font-semibold tracking-wide uppercase text-sm mb-2">
            Our Blog Post
          </h4>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Latest Articles from Daily Go
          </h2>
        </div>

        {/* Loader */}
        {loading && (
          <p className="text-center text-gray-600">Loading blogs...</p>
        )}

        {/* Blog Cards */}
        <div className="grid gap-8 md:grid-cols-3">
          {!loading && blogs.length === 0 && (
            <p className="text-gray-600 text-center w-full col-span-3">
              No blogs available yet.
            </p>
          )}

          {blogs.map((post) => (
            <div
              key={post._id}
              className="bg-white rounded-2xl border border-amber-200 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col"
            >
              {/* Blog Image */}
              <div className="relative w-full h-60">
                <img
                  src={
                    post.image
                      ? `${IMAGE_BASE_URL}${post.image}`
                      : "https://via.placeholder.com/400x300"
                  }
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>

              {/* Blog Content */}
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center text-gray-500 text-sm mb-3">
                  <Calendar className="w-4 h-4 mr-2" />
                  {new Date(post.date).toDateString()}
                </div>
                <h3 className="font-semibold text-lg text-gray-900 mb-3">
                  {post.title}
                </h3>
                <p className="text-gray-600 text-sm flex-grow">
                  {post.description?.slice(0, 120)}...
                  <a
                    href={post.link || "#"}
                    className="text-amber-700 font-medium hover:underline ml-1"
                  >
                    see more
                  </a>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogsCards;
